function cov_rj37e65fs() {
  var path = "/app/src/hooks/use-should-show-long-term-content.ts";
  var hash = "513a543061bd592f995ac1589785f6f0527fbcf1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/hooks/use-should-show-long-term-content.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 44
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 40
        },
        end: {
          line: 6,
          column: 55
        }
      },
      "2": {
        start: {
          line: 8,
          column: 29
        },
        end: {
          line: 8,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 13,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 44
          },
          end: {
            line: 5,
            column: 45
          }
        },
        loc: {
          start: {
            line: 5,
            column: 50
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 12,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 22
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 12,
            column: 65
          }
        }],
        line: 11
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "513a543061bd592f995ac1589785f6f0527fbcf1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_rj37e65fs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_rj37e65fs();
import { LTF_CURRENCY_LIST } from 'src/constants/common';
import { useAppContext } from 'src/context/store/app-provider';
cov_rj37e65fs().s[0]++;
export var useShouldShowLongTermContent = function useShouldShowLongTermContent() {
  var _offers$installments;
  cov_rj37e65fs().f[0]++;
  var _ref = (cov_rj37e65fs().s[1]++, useAppContext()),
    formattedCurrency = _ref.formattedCurrency,
    offers = _ref.offers;
  var hasConfiguredPlans = (cov_rj37e65fs().s[2]++, ((_offers$installments = offers.installments) === null || _offers$installments === void 0 ? void 0 : _offers$installments.length) !== 0);
  cov_rj37e65fs().s[3]++;
  return (cov_rj37e65fs().b[0][0]++, hasConfiguredPlans) || (cov_rj37e65fs().b[0][1]++, LTF_CURRENCY_LIST.includes(formattedCurrency));
};